<template>
    <div class="ip-stat-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-data-analysis"></i>
                    <span>IP访问频率统计</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="queryParams" class="filter-form" ref="queryForm">
                <el-form-item label="统计日期">
                    <el-date-picker
                        v-model="queryParams.day"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :disabled="queryParams.allDays"
                        style="width: 200px"
                    />
                </el-form-item>
                <el-form-item label="汇总所有天">
                    <el-switch v-model="queryParams.allDays" @change="handleAllDaysChange"/>
                </el-form-item>
                <el-form-item label="IP地址">
                    <el-input clearable v-model="queryParams.ipAddress" placeholder="请输入IP（模糊）" style="width: 200px"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                    <span class="header-tip">{{ queryParams.allDays ? '汇总所有天' : (queryParams.day || '当天') }}</span>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                v-loading="loading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="80" align="center"/>
                <el-table-column prop="ipAddress" label="IP地址" width="160" align="center"/>
                <el-table-column prop="ipRegion" label="归属地" min-width="160" align="center" show-overflow-tooltip/>
                <el-table-column prop="count" label="访问次数" width="120" align="center" sortable>
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.count >= 200" effect="plain">{{ scope.row.count }}</el-tag>
                        <span v-else>{{ scope.row.count }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="标签" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.labelName" type="success" effect="plain">{{ scope.row.labelName }}</el-tag>
                        <span v-else style="color: #c0c4cc">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="360" align="center" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-collection-tag" @click="handleMark(scope.row)">标记</el-button>
                            <el-button
                                type="info"
                                size="mini"
                                icon="el-icon-close"
                                :disabled="!scope.row.labelName"
                                @click="handleUnmark(scope.row)"
                            >取消标记</el-button>
                            <el-button type="danger" size="mini" icon="el-icon-remove-outline" @click="handleBlacklist(scope.row)">拉黑</el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="queryParams.pageNum"
                    :page-size="queryParams.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 标记对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            title="标记IP"
            :visible.sync="dialogVisible"
            width="520px"
            class="ip-stat-dialog"
            @closed="resetForm">
            <el-form :model="form" :rules="rules" ref="form" label-width="90px">
                <el-form-item label="IP地址">
                    <el-input v-model="form.ipAddress" disabled/>
                </el-form-item>
                <el-form-item label="标签名称" prop="labelName">
                    <el-input v-model="form.labelName" placeholder="如：本机" clearable/>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input
                        v-model="form.remark"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入备注（选填）"
                        maxlength="255"
                        show-word-limit
                    />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqIpStatPage, reqIpLabelSave, reqIpLabelDelete, reqIpStatDelete } from '@/api/system/ipStat'
import { reqIpBlacklistAdd } from '@/api/system/ipBlacklist'

function formatDate(date, fmt) {
    const p = (n) => (n < 10 ? '0' + n : '' + n)
    const y = date.getFullYear()
    const m = p(date.getMonth() + 1)
    const d = p(date.getDate())
    return fmt.replace('yyyy', y).replace('MM', m).replace('dd', d)
}

export default {
    name: 'IpStat',
    data() {
        return {
            loading: false,
            submitLoading: false,
            tableData: [],
            total: 0,
            queryParams: {
                pageNum: 1,
                pageSize: 20,
                day: undefined,
                allDays: true,
                ipAddress: undefined
            },
            dialogVisible: false,
            form: {
                ipAddress: undefined,
                labelName: '本机',
                remark: undefined
            },
            rules: {
                labelName: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        /** 加载数据 */
        async load() {
            this.loading = true
            const params = {
                pageNum: this.queryParams.pageNum,
                pageSize: this.queryParams.pageSize
            }
            if (!this.queryParams.allDays && this.queryParams.day) {
                params.day = this.queryParams.day
            }
            if (this.queryParams.ipAddress) {
                params.ipAddress = this.queryParams.ipAddress
            }
            try {
                const data = await reqIpStatPage(params)
                this.tableData = data.records || []
                this.total = data.total || 0
            } catch (e) {
                console.error('加载IP统计失败:', e)
            } finally {
                this.loading = false
            }
        },

        /** 汇总所有天开关变化 */
        handleAllDaysChange(val) {
            if (val) {
                this.queryParams.day = undefined
            } else {
                this.queryParams.day = formatDate(new Date(), 'yyyy-MM-dd')
            }
            this.handleSearch()
        },

        /** 查询 */
        handleSearch() {
            this.queryParams.pageNum = 1
            this.load()
        },

        /** 重置 */
        handleReset() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 20,
                day: undefined,
                allDays: true,
                ipAddress: undefined
            }
            this.load()
        },

        /** 分页大小变化 */
        handleSizeChange(val) {
            this.queryParams.pageSize = val
            this.queryParams.pageNum = 1
            this.load()
        },

        /** 当前页变化 */
        handleCurrentChange(val) {
            this.queryParams.pageNum = val
            this.load()
        },

        /** 打开标记对话框 */
        handleMark(row) {
            this.form = { ipAddress: row.ipAddress, labelName: '本机', remark: undefined }
            this.dialogVisible = true
        },

        /** 重置表单 */
        resetForm() {
            this.form = { ipAddress: undefined, labelName: '本机', remark: undefined }
            if (this.$refs.form) {
                this.$refs.form.clearValidate()
            }
        },

        /** 提交标记 */
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return
                this.submitLoading = true
                reqIpLabelSave({
                    ipAddress: this.form.ipAddress,
                    labelName: this.form.labelName,
                    remark: this.form.remark
                }).then(() => {
                    this.$message.success('标记成功')
                    this.dialogVisible = false
                    this.load()
                }).catch(() => {}).finally(() => {
                    this.submitLoading = false
                })
            })
        },

        /** 取消标记 */
        handleUnmark(row) {
            this.$confirm(`确认取消 IP「${row.ipAddress}」的标签吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return reqIpLabelDelete(row.ipAddress)
            }).then(() => {
                this.$message.success('已取消标记')
                this.load()
            }).catch(() => {})
        },

        /** 拉黑：确认后直接加入IP黑名单 */
        handleBlacklist(row) {
            this.$confirm(`确认将 IP「${row.ipAddress}」（访问 ${row.count} 次）加入黑名单吗？`, '拉黑确认', {
                confirmButtonText: '确定拉黑',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return reqIpBlacklistAdd({
                    ipAddress: row.ipAddress,
                    reason: '来自访问统计手动拉黑'
                })
            }).then(() => {
                this.$message.success('已加入黑名单')
                this.load()
            }).catch(() => {})
        },

        /** 删除：删除该IP的频率统计及对应的操作日志 */
        handleDelete(row) {
            this.$confirm(`确认删除 IP「${row.ipAddress}」的访问频率统计及其所有操作日志吗？删除后不可恢复。`, '删除确认', {
                confirmButtonText: '确定删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                return reqIpStatDelete(row.ipAddress)
            }).then(() => {
                this.$message.success('删除成功')
                this.load()
            }).catch(() => {})
        }
    }
}
</script>

<style scoped lang="scss">
.ip-stat-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .header-tip {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }
}

@media screen and (max-width: 768px) {
    .ip-stat-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }
    }
}
</style>
